import { css } from "../../../../../styled-system/css";
import { t } from "../../../../libs/i18n";
import { Heading } from "./heading";

export const OsakiCampaignDetail = () => {
  return (
    <div
      className={css({
        display: "flex",
        flexDirection: "column",
        gap: "12px",
      })}
    >
      <Heading>{t("ポイント付与について")}</Heading>
      <p
        className={css({
          fontSize: "16px",
          lineHeight: "1.5",
          letterSpacing: "0.16px",
          color: "text.primary",
        })}
      >
        {t(
          "大崎市では物価高騰の影響を受けている市民を支援するため、国の「物価高騰対応重点支援地方創生臨時交付金／重点支援地方交付金」を活用し、大崎市民全員に1人あたり5,000ポイントをプレゼントします。",
        )}
        <br />
        <br />
        {t(
          "応募すると、ただちにポイント付与し、対象店舗で1ポイント＝1円として利用できます。",
        )}
      </p>
      <p
        className={css({
          fontSize: "16px",
          lineHeight: "1.5",
          letterSpacing: "0.16px",
          color: "text.primary",
          mt: "24px",
        })}
      >
        {t("■ポイント取得期限")}
        <br />
        {t("2026年2月28日まで")}
      </p>
      <p
        className={css({
          fontSize: "16px",
          lineHeight: "1.5",
          letterSpacing: "0.16px",
          color: "text.primary",
          mt: "12px",
        })}
      >
        {t("■ポイント利用期限")}
        <br />
        {t("2026年5月31日まで")}
        <br />
        {t("（6月1日となった時点でポイントが失効します）")}
      </p>
    </div>
  );
};
